import type { JanelaReferencia, JanelaRelacao, JanelaUnidade } from "@/modules/recursos";

export type JanelaTipo = "entrada" | "saida";

export const JANELA_COPY: Record<JanelaTipo, { title: string; checkbox: string }> = {
  entrada: { title: "Entrada", checkbox: "O profissional entra no início da obra" },
  saida: { title: "Saída", checkbox: "O profissional sai no término da obra" },
};

export const UNIDADE_OPTIONS: { label: string; value: JanelaUnidade }[] = [
  { label: "dias", value: "dias" },
  { label: "meses", value: "meses" },
];

export const RELACAO_OPTIONS: { label: string; value: JanelaRelacao }[] = [
  { label: "antes do", value: "ANTES" },
  { label: "depois do", value: "DEPOIS" },
];

export const MARCO_OPTIONS: { label: string; value: JanelaReferencia }[] = [
  { label: "Início da obra", value: "INICIO" },
  { label: "Término da obra", value: "TERMINO" },
];

export const VALOR_MAX_LENGTH = 4;
